export default __webpack_public_path__ + "static/media/team2.0ddaf97c.png";